import React from 'react';

import { useChain } from 'contexts';

type Props = React.ButtonHTMLAttributes<HTMLButtonElement> & {
  padded?: boolean;
};

const Button: React.FC<Props> = ({ padded = true, ...buttonProps }) => {
  const { styleSlug } = useChain();
  return (
    <div
      className={`rounded-full bg-${styleSlug}-light bg-gradient-to-l dark:from-${styleSlug}-light dark:to-${styleSlug}-primary`}
      style={{ padding: 2, height: 42, width: padded ? 'auto' : 42 }}
    >
      <button
        className={`h-full rounded-full focus:outline-none bg-white dark:bg-gray-111 text-${styleSlug}-primary dark:text-${styleSlug}-light text-sm ${
          padded ? 'px-4 md:px-5 py-1 md:py-2' : 'w-full'
        }`}
        {...buttonProps}
      />
    </div>
  );
};

export default Button;
